import Toggle from "../../../controls/Toggle";
import { ComponentEx } from "../../../controls/ComponentEx";
import { setCleanupOnDeploy } from "../actions/settings";
import * as React from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
class Settings extends ComponentEx {
    render() {
        const { t, cleanupOnDeploy } = this.props;
        return (React.createElement("form", null,
            React.createElement(FormGroup, { controlId: "cleanup-on-deploy" },
                React.createElement(ControlLabel, null, t("Clean up empty directories ")),
                React.createElement(Toggle, { checked: cleanupOnDeploy, onToggle: this.toggle }, t("Clean up empty directories during deployment")),
                React.createElement(HelpBlock, null, t("By default Vortex will only remove empty directories during deployment " +
                    "if the game or related tools would otherwise not work correctly.\n" +
                    "Usually empty directories cause no harm and cleaning them up takes " +
                    "some extra time during deployment so " +
                    "we advise you only enable this option if you're experience problems we didn't " +
                    "anticipate. In that case please also inform us.")))));
    }
    toggle = (enabled) => {
        const { onSetCleanupOnDeploy } = this.props;
        onSetCleanupOnDeploy(enabled);
    };
}
function mapStateToProps(state) {
    return {
        cleanupOnDeploy: state.settings.mods.cleanupOnDeploy,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetCleanupOnDeploy: (enable) => dispatch(setCleanupOnDeploy(enable)),
    };
}
export default withTranslation(["common"])(connect(mapStateToProps, mapDispatchToProps)(Settings));
